import { usePaymentPresentationLocale } from '../lib/usePaymentPresentationLocale'
import React, { useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'

export default function PublicEventGuestPaymentPage() {
  const { t, locale } = usePaymentPresentationLocale(true)
  const { token } = useParams()
  const [searchParams] = useSearchParams()
  const clubCode = searchParams.get('club_code') || searchParams.get('clubCode') || ''
  const [state, setState] = useState({ loading: true, data: null, error: '' })

  useEffect(() => {
    let active = true
    fetch(`/api/public/event-guest-payments/${encodeURIComponent(token)}?club_code=${encodeURIComponent(clubCode)}`)
      .then((res) => res.json().then((payload) => ({ res, payload })))
      .then(({ res, payload }) => {
        if (!active) return
        setState({ loading: false, data: res.ok && payload?.ok !== false ? payload.data : null, error: res.ok ? '' : (payload?.error || 'invalid_token') })
      })
      .catch(() => active && setState({ loading: false, data: null, error: 'load_failed' }))
    return () => { active = false }
  }, [token, clubCode])

  const startCheckout = async () => {
    const res = await fetch(`/api/public/event-guest-payments/${encodeURIComponent(token)}/checkout`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ club_code: clubCode }) })
    const payload = await res.json()
    if (payload?.url) window.location.href = payload.url
    else setState((current) => ({ ...current, error: payload?.error || 'checkout_failed' }))
  }

  if (state.loading) return <main className="mp-public-page" lang={locale}><section className="mp-card"> {t("portalPresentation.member_loading_secure_payment_link")} </section></main>
  if (state.error) return <main className="mp-public-page" lang={locale}><section className="mp-card"><p className="mp-eyebrow">Privana Pay</p><h1> {t("portalPresentation.member_payment_link_unavailable")} </h1><p> {t("portalPresentation.member_this_guest_payment_token_is_invalid_or_expired")} </p></section></main>
  const data = state.data || {}
  const start = data.event?.start_at ? new Date(data.event.start_at) : null
  const dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(String(data.event?.start_at || ''))
  const eventTime = start && Number.isFinite(start.getTime())
    ? new Intl.DateTimeFormat(locale, { dateStyle: 'long', ...(dateOnly ? { timeZone: 'UTC' } : { timeStyle: 'short', ...(data.event?.timezone ? { timeZone: data.event.timezone } : {}) }) }).format(start)
    : t('portalPresentation.member_date_time_tbc')
  return (
    <main className="mp-public-page" lang={locale}>
      <section className="mp-card">
        <p className="mp-eyebrow"> {t("portalPresentation.member_privana_guest_payment")} </p>
        <h1>{data.event?.title || t("portalPresentation.member_event_guest_ticket")}</h1>
        <p>{eventTime} · {data.event?.location || t("portalPresentation.member_club_venue")}</p>
        <div className="mp-summary-section"><p className="mp-label">{t("membersStaff.guest")}</p><div className="mp-value">{data.guest_name || t("membersStaff.guest")}</div></div>
        <div className="mp-summary-section"><p className="mp-label">{t("portalPresentation.amount_due")}</p><div className="mp-value">{new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(data.amount_due || 0))}</div></div>
        {data.payment_status === 'paid_online' ? <p> {t("portalPresentation.member_paid_online_thank_you")} </p> : <button type="button" className="mp-primary" onClick={startCheckout}> {t("portalPresentation.member_pay_securely_with_privana_pay")} </button>}
      </section>
    </main>
  )
}
